import api from '@/interface/baseApi'
export function wxInitGet(data) {
    return api({
        url: '/wangshangdai/customer/getWxPageCfg',
        method: 'post',
        data
    })
}
